var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatePickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1401 2.44287H17.1401V0.442871H15.1401V2.44287H5.14014V0.442871H3.14014V2.44287H2.14014C1.04014 2.44287 0.140137 3.34287 0.140137 4.44287V20.4429C0.140137 21.5429 1.04014 22.4429 2.14014 22.4429H18.1401C19.2401 22.4429 20.1401 21.5429 20.1401 20.4429V4.44287C20.1401 3.34287 19.2401 2.44287 18.1401 2.44287ZM18.1401 20.4429H2.14014V9.44287H18.1401V20.4429ZM18.1401 7.44287H2.14014V4.44287H18.1401V7.44287Z",
    fill: "#42495E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerIcon);
export default __webpack_public_path__ + "static/media/DatePickerIcon.f93ff9d2.svg";
export { ForwardRef as ReactComponent };